'use client'

import React, { useRef } from 'react'

import { HourSelect } from '@/components/common/Timepicker/HourSelect'
import { MinuteSelect } from '@/components/common/Timepicker/MinuteSelect'
import { TimePeriodSelect } from '@/components/common/Timepicker/PeriodSelect'

import type { Period } from '@/helpers/date'

interface Timepicker {
  date: Date | undefined
  setDate: (date: Date | undefined) => void
}

const Timepicker: React.FC<Timepicker> = ({ date, setDate }) => {
  const period: Period = date && date.getHours() >= 12 ? 'PM' : 'AM'
  const periodRef = useRef<HTMLButtonElement | null>(null)

  return (
    <div className="grid grid-cols-3 items-end gap-2 w-full">
      <div className="grid gap-1">
        <label
          htmlFor="hours"
          className="text-xs text-primary-900 dark:text-primary-100"
        >
          Hour
        </label>
        <HourSelect value={date} setValue={setDate} />
      </div>
      <div className="grid gap-1">
        <label
          htmlFor="minutes"
          className="text-xs text-primary-900 dark:text-primary-100"
        >
          Minute
        </label>
        <MinuteSelect value={date} setValue={setDate} />
      </div>
      <div className="grid gap-1">
        <label
          htmlFor="period"
          className="text-xs text-primary-900 dark:text-primary-100"
        >
          Period
        </label>
        <TimePeriodSelect
          period={period}
          date={date}
          setDate={setDate}
          ref={periodRef}
        />
      </div>
    </div>
  )
}

export default Timepicker
